import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const BusPictogram = t0 => {
  const $ = _c(5);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path fillRule="evenodd" clipRule="evenodd" d="M14.4247 13.4841H13.4353V14.8381C13.4353 15.3068 13.0578 15.6843 12.5891 15.6843H11.4174C10.9487 15.6843 10.5712 15.3068 10.5712 14.8381V13.4972H5.40277V14.8381C5.40277 15.3068 5.02522 15.6843 4.55655 15.6843H3.38487C2.91619 15.6843 2.53865 15.3068 2.53865 14.8381V13.4972H1.56225V2.82181C1.56225 1.83238 2.13507 1.11635 3.29373 0.673719C5.58503 -0.224573 10.402 -0.224573 12.7063 0.673719C13.8649 1.11635 14.4378 1.83238 14.4378 2.82181V13.4841H14.4247ZM15.4402 5.25631H14.9455V8.06835H15.4402C15.7526 8.06835 16 7.82099 16 7.50854V5.81611C16 5.50366 15.7526 5.25631 15.4402 5.25631ZM0.559805 5.25631H1.05452V8.06835H0.559805C0.247356 8.06835 0 7.82099 0 7.50854V5.81611C0 5.50366 0.247356 5.25631 0.559805 5.25631ZM6.04068 1.11636H9.95932C10.0765 1.11636 10.1676 1.20749 10.1676 1.32465V2.00163C10.1676 2.1188 10.0765 2.20993 9.95932 2.20993H6.04068C5.92352 2.20993 5.83238 2.1188 5.83238 2.00163V1.32465C5.83238 1.20749 5.92352 1.11636 6.04068 1.11636ZM2.98129 3.01709H12.9666C13.0968 3.01709 13.214 3.13426 13.214 3.26444V8.83645C13.214 8.96664 13.0968 9.08381 12.9666 9.08381H2.98129C2.8511 9.08381 2.73393 8.96664 2.73393 8.83645V3.26444C2.73393 3.13426 2.83808 3.01709 2.98129 3.01709ZM12.8365 11.0496C12.8365 10.8023 12.7453 10.581 12.5761 10.4117C12.4068 10.2425 12.1855 10.1513 11.9382 10.1513C11.6908 10.1513 11.4825 10.2425 11.3002 10.4117C11.118 10.581 11.0399 10.8023 11.0399 11.0496C11.0399 11.297 11.131 11.5053 11.3002 11.6745C11.4825 11.8438 11.6908 11.9349 11.9382 11.9349C12.1855 11.9349 12.4068 11.8438 12.5761 11.6745C12.7583 11.5053 12.8365 11.297 12.8365 11.0496ZM4.96013 11.0496C4.96013 10.8023 4.869 10.581 4.69976 10.4117C4.53051 10.2425 4.30919 10.1513 4.06184 10.1513C3.81448 10.1513 3.59316 10.2425 3.42392 10.4117C3.25468 10.581 3.16355 10.8023 3.16355 11.0496C3.16355 11.297 3.24166 11.5053 3.42392 11.6745C3.59316 11.8438 3.81448 11.9349 4.06184 11.9349C4.32221 11.9349 4.53051 11.8438 4.69976 11.6745C4.869 11.5053 4.96013 11.297 4.96013 11.0496Z" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props) {
    t2 = <IconWrapper {...props} variant="solid" viewBox="0 0 16 15.6843">{t1}</IconWrapper>;
    $[3] = props;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export { BusPictogram };